import { useMemo } from 'react';
import Markdown from 'react-markdown';
import { InterpolatedJnxTemplate } from '../../util/jnx';


function TextDisplay({ element, scope }) {
  const {
    label='',
    'classNames': classNames
  } = element;

  const bindings = useMemo(() => ({ rootFormData: scope }), [scope]);
  const interpJnx = useMemo(() => new InterpolatedJnxTemplate(label), [label]);
  const text = useMemo(() => interpJnx.eval(bindings.rootFormData ?? {}, '', bindings, false), [interpJnx, bindings]);

  return (
    <div className={`align-self-sm-center label ${classNames ?? ''}`}>
      <Markdown>{text}</Markdown>
    </div>
  );
}


TextDisplay.rootSchema = {
  'properties': {
    'label': {
      'title': 'Label',
      'type': 'string',
      ':classNames': 'from-col-1-size-3',
      'ui:widget': 'textarea',
      'map:field': 'label'
    },
    'classNames': {
      'title': 'Classes',
      'type': 'string',
      ':classNames': 'from-col-1-size-3',
      'map:field': 'classNames'
    }
  }
};


function NewlineText(props) {
  return props.text.split('\n').map((str, idx) => <p key={idx}>{str}</p>);
}

export default TextDisplay;
